export default {"src":"/_next/static/media/calendar.3f3fc0ee.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};